// extracted by mini-css-extract-plugin
export default {"tab":"ArticleForm_tab__+wMKm"};